const cascoPartnerResources = {
  en: {
    cascoPartner: {
      doscarTitle: 'CASCO DOSCAR',
      astanaMotorsTitle: 'CASCO Astana Motors',
      calculator: 'Insurance calculator',
      'description.title': 'Description',
      doscarDescriptionText:
        'Страхование автотранспорта - выгодно всегда! У владельца автотранспорта множество рисков, которые не зависят от его умения управлять транспортным средством и его опыта вождения. При наличии полиса КАСКО, Вам не придется оплачивать расходы из своего кармана, ущерб покроет страховая компания.',
      doscarProgramOneTitle: 'Программа 1',
      doscarProgramOneHtml: `<p><span style="font-weight: 700;">На страхование принимается</span>&nbsp;легковой транспорт не
      старше 7 лет</p>
    <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
      повреждения ТС в результате:</p>
    <ul>
      <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
      <li id="pr_ul12">
        противоправные действия третьих лиц</li>
      <li id="pr_ul13">
        стихийные бедствия</li>
      <li id="pr_ul14">
        иные непредвиденные события</li>
    </ul>
    <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
    <ul>
      <li>при частичном повреждении страховая выплата осуществляется страховщиком путем
        восстановления автомобильного транспорта на<span style="font-weight: 700;">&nbsp;специализированном СТО.</span></li>
    </ul>
    <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
      страховой суммы</p>`,
      doscarProgramTwoTitle: 'Программа 2',
      doscarProgramTwoHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 7 лет</p>
<p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
  повреждения ТС в результате:</p>
<ul>
  <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
  <li id="pr_ul12">
    противоправные действия третьих лиц</li>
  <li id="pr_ul13">
    стихийные бедствия</li>
  <li id="pr_ul14">
    иные непредвиденные события</li>
  <li id="pr_ul16">
    повреждения стекол/оптики, повреждения транспортного средства от камней из-под колес</li>
</ul>
<p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
<ul>
  <li>при частичном повреждении страховая выплата осуществляется страховщиком путем
    восстановления автомобильного транспорта на<span style="font-weight: 700;">&nbsp;специализированном СТО.</span></li>
</ul>
<p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
  страховой суммы</p>`,
    },
  },
  kz: {
    cascoPartner: {
      doscarTitle: 'КАСКО DOSCAR',
      astanaMotorsTitle: 'КАСКО Astana Motors',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      doscarDescriptionText:
        'Автокөлікті сақтандыру - әрқашанда тиімді! Автокөлік иесінің көлік құралын басқару қабілетіне және жүргізу тәжірибесіне тәуелді емес көптеген тәуекелдері бар. Егер Сізде КАСКО полисі болса, шығындарды өз қалтаңыздан төлеудің қажеті жоқ, залалды сақтандыру компаниясы жабады.',
      doscarProgramOneTitle: '1-бағдарлама',
      doscarProgramOneHtml: `<p><span style="font-weight: 700;">Сақтандыруға</span>&nbsp;7 жылдан үлкен емесе жеңіл автокөлік қабылданады.</p>
<p><span style="font-weight: 700;">Сақтандыру жағдайы</span>&nbsp;төмендегілердің салдарынан КҚ-ны жоғалту (оның опат
  болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li id="pr_ul11">жол-көлік оқиғасы (ЖКО)</li>
  <li id="pr_ul12">
    үшінші тұлғалардың құқыққа қайшы әрекеттері</li>
  <li id="pr_ul13">
    табиғи апаттар</li>
  <li id="pr_ul14">
    басқа күтпеген оқиғалар</li>
</ul>
<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ішінара бүлінген жағдайда сақтандыру төлемін сақтандырушы<span style="font-weight: 700;">&nbsp;мамандандырылған
      ТҚС-та</span> автомобиль көлігін қалпына келтіру жолымен
    жүзеге асырады.</li>
</ul>
<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span>&nbsp;12 ай, сақтандыру сомасы таусылғанға дейін</p>`,
      doscarProgramTwoTitle: '2-бағдарлама',
      doscarProgramTwoHtml: `<p><span style="font-weight: 700;">Сақтандыруға</span>&nbsp;7 жылдан үлкен емесе жеңіл автокөлік қабылданады.</p>
<p><span style="font-weight: 700;">Сақтандыру жағдайы</span>&nbsp;төмендегілердің салдарынан КҚ-ны жоғалту (оның опат
  болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li id="pr_ul11">жол-көлік оқиғасы (ЖКО)</li>
  <li id="pr_ul12">
    үшінші тұлғалардың құқыққа қайшы әрекеттері
  </li>
  <li id="pr_ul13">
    табиғи апаттар
  </li>
  <li id="pr_ul14">
    басқа күтпеген оқиғалар
  </li>
  <li id="pr_ul16">
    әйнектің/оптиканың зақымдануы, доңғалақ астынан ұшқан тастардан
    зақымдануы
  </li>
</ul>
<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ішінара бүлінген жағдайда сақтандыру төлемін сақтандырушы<span style="font-weight: 700;">&nbsp;мамандандырылған
      ТҚС-та</span> автомобиль көлігін қалпына келтіру жолымен
    жүзеге асырады.
  </li>
</ul>
<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span>&nbsp;12 ай, сақтандыру сомасы таусылғанға дейін</p>`,
    },
  },
  ru: {
    cascoPartner: {
      doscarTitle: 'КАСКО DOSCAR',
      astanaMotorsTitle: 'КАСКО Astana Motors',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      doscarDescriptionText:
        'Страхование автотранспорта - выгодно всегда! У владельца автотранспорта множество рисков, которые не зависят от его умения управлять транспортным средством и его опыта вождения. При наличии полиса КАСКО, Вам не придется оплачивать расходы из своего кармана, ущерб покроет страховая компания.',
      doscarProgramOneTitle: 'Программа 1',
      doscarProgramOneHtml: `<p><span style="font-weight: 700;">На страхование принимается</span>&nbsp;легковой транспорт не
      старше 7 лет</p>
    <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
      повреждения ТС в результате:</p>
    <ul>
      <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
      <li id="pr_ul12">
        противоправные действия третьих лиц</li>
      <li id="pr_ul13">
        стихийные бедствия</li>
      <li id="pr_ul14">
        иные непредвиденные события</li>
    </ul>
    <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
    <ul>
      <li>при частичном повреждении страховая выплата осуществляется страховщиком путем
        восстановления автомобильного транспорта на<span style="font-weight: 700;">&nbsp;специализированном СТО.</span></li>
    </ul>
    <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
      страховой суммы</p>`,
      doscarProgramTwoTitle: 'Программа 2',
      doscarProgramTwoHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 7 лет</p>
<p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
  повреждения ТС в результате:</p>
<ul>
  <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
  <li id="pr_ul12">
    противоправные действия третьих лиц</li>
  <li id="pr_ul13">
    стихийные бедствия</li>
  <li id="pr_ul14">
    иные непредвиденные события</li>
  <li id="pr_ul16">
    повреждения стекол/оптики, повреждения транспортного средства от камней из-под колес</li>
</ul>
<p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
<ul>
  <li>при частичном повреждении страховая выплата осуществляется страховщиком путем
    восстановления автомобильного транспорта на<span style="font-weight: 700;">&nbsp;специализированном СТО.</span></li>
</ul>
<p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
  страховой суммы</p>`,
    },
  },
};

export default cascoPartnerResources;
